import React from 'react';

/** Logo oficial Shopify (bolsa verde con S) */
const ShopifyIcon = ({ size = 20, className = '' }) => (
  <img
    src="/shopify-icon.png"
    alt=""
    width={size}
    height={size}
    className={`shopify-icon-img ${className}`.trim()}
    decoding="async"
    aria-hidden="true"
  />
);

export default ShopifyIcon;
